import type { ReactNode } from 'react'

type CollapseItemProps = {
  children: ReactNode
}

const CollapseItem = ({ children }: CollapseItemProps) => {
  return <div slot='collapsed'>{children}</div>
}

export default CollapseItem
